import { render } from "./DownloadSuccessModal.vue?vue&type=template&id=a1870e5c&scoped=true"
import script from "./DownloadSuccessModal.vue?vue&type=script&lang=js"
export * from "./DownloadSuccessModal.vue?vue&type=script&lang=js"

import "./DownloadSuccessModal.vue?vue&type=style&index=0&id=a1870e5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1870e5c"]])

export default __exports__